import { render, staticRenderFns } from "./repairType3.vue?vue&type=template&id=94222c82&scoped=true&"
import script from "./repairType3.vue?vue&type=script&lang=js&"
export * from "./repairType3.vue?vue&type=script&lang=js&"
import style0 from "./repairType3.vue?vue&type=style&index=0&id=94222c82&lang=scss&scoped=true&"
import style1 from "./repairType3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94222c82",
  null
  
)

export default component.exports